import React from "react";
import { Card, Empty } from "antd";
import { UI_COLORS } from "../../config";

export default function NoTenantPlaceholder() {
  return (
    <div className="w-full md:h-full">
      <Card size="small" className="h-full flex items-center justify-center">
        <Empty
          image={<img src="/logo-RINA-DPP.png" alt="RINA Logo DPP" />}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          styles={{ image: { height: 240 } }}
          description={
            <h2
              className="text-xl font-semibold truncate"
              style={{
                color: UI_COLORS.primary,
                paddingTop: 8,
                paddingBottom: 8,
              }}
            >
              Please select a tenant to access its information
            </h2>
          }
        />
      </Card>
    </div>
  );
}